module.exports = __webpack_public_path__ + "static/media/8.77475f6d.svg";